import React from "react";
import { useAutoImportFormContext } from "../../Context/AutoImportFormContext";
import styles from "../AddEditAutoImportConfigurationsModal.module.css";
import { LRequiredInput } from "./CommonComponents/LRequiredInput";
import { FormGrid } from "./CommonComponents/FormGrid";

function PgpDecryptionForm() {
  const { formData, updateStepData } = useAutoImportFormContext();
  const { pgpDecryption } = formData;

  const inputs = [
    {
      colSpan: 12,
      render: () => (
        <div className={styles.checkboxInputAlign}>
          <LRequiredInput
            type="checkbox"
            required
            labelName="Use PGP Decryption"
            checkbox={{
              value: pgpDecryption.usePgpDecryption,
              checked: pgpDecryption.usePgpDecryption,
              onChange: (e: any) => updateStepData("pgpDecryption", { usePgpDecryption: e.value })}}
          />
        </div>
      ),
    },
    {
      colSpan: 12,
      render: () => (
        <LRequiredInput
          required={pgpDecryption.usePgpDecryption}
          type="input"
          labelAlign="top"
          labelName="Pass Phrase"
          input={{
            name: "Pass Phrase",
            placeholder: "Enter Pass Phrase",
            value: pgpDecryption.pgpPassPhrase,
            onChange: (e: React.ChangeEvent<HTMLInputElement>) => updateStepData("pgpDecryption", {pgpPassPhrase: e.target.value}),
            disabled: !pgpDecryption.usePgpDecryption,
          }}
        />
      ),
    },
    {
      colSpan: 12,
      render: () => (
        <div className={styles.comboBoxLabelAlign}>
          <LRequiredInput
            required={pgpDecryption.usePgpDecryption}
            type="TextArea"
            labelAlign="top"
            labelName="Private Key"
            textArea={{
              name: "Private Key",
              placeholder: "Enter Private Key",
              value: pgpDecryption.pgpPrivateKey,
              onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => updateStepData("pgpDecryption", {pgpPrivateKey: e.target.value}),
              disabled: !pgpDecryption.usePgpDecryption,
            }}
          />
        </div>
      ),
    },
  ];

  return <FormGrid items={inputs} />;
}
export { PgpDecryptionForm };